import axios from "axios";
import loading from "@/components/loading/loading";
import router from "../router";
// create an axios instance
const service = axios.create({
    // baseURL: process.env.VUE_APP_BASE_API,
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    withCredentials: false, // 是否允许带cookie这些
    timeout: 200000, // request timeout
});
// request interceptor
service.interceptors.request.use(
    (config) => {
        // do something before request is sent
        // 设置头信息
        config.headers["username"] = localStorage.getItem("username");
        config.headers["token"] = localStorage.getItem("token");
        config.headers['language']=localStorage.getItem("language") || 'zh';
        config.headers["debug"] = process.env.NODE_ENV === "development" ? 1 : 0;
        loading.load();
        return config;
    },
    (error) => {
        console.log(error); // for debug
        loading.hide();
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    (response) => {
        // 检查响应类型，如果是blob，直接返回response
        if (response.config.responseType === "blob") {
            console.log("[ blob ]", "request.js  34 ->");
            loading.hide();
            return response;
        }
        const res = response.data;

        loading.hide();
        console.log("[ res ]", "request.js  40 ->", res);

        if (res.code !== 200) {
            console.log("Error", res.message || "Error");
            if (res.code === 4001) {
                router.push("/login");
                return;
            } else if (res.code === 50000) {
                // Vue.prototype.$notify({ type: "warning", message: res.message });
                return res;
            } else {
                // Vue.prototype.$notify({ type: "warning", message: res.message });

                return res;
            }
        } else {
            return res;
        }
    },
    (error) => {
        loading.hide();
        let mesage = ''
        if (error.code === "ECONNABORTED" || error.message === "Network Error" || error.message.includes("timeout")) {
            // Vue.prototype.$notify({ type: "warning", message: "Network Error" });

            return Promise.reject("Network Error");

        }

        if (error.request.status === 401) {
            mesage = {
                code: 401,
                message: 'token过期',
                data: ''
            }
        }
        if (error.request.status === 412) {
            window.location.reload();
            return Promise.reject(new Error(error.message || "Error"));
        }
        if (error.request.status === 404) {
            mesage = {
                code: 404,
                message: '请求地址不存在',
                data: ''
            }
        }


        return Promise.reject(mesage);
    }
);

export default service;
